import { useFormContext } from 'react-hook-form';
import { TextField } from '@client/new/components/basic';
import { FieldLabel } from '../primitives/FieldLabel';
import * as styles from './itemFields.css';
import { ProgramFormValues } from '../../model/programForm.types';

export type FaqItemProps = {
  index: number;
  isSubmitting?: boolean;
};

export const FaqItem = ({ index, isSubmitting }: FaqItemProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ProgramFormValues>();
  const rowErrors = errors.faqs?.[index];

  return (
    <>
      <div className={styles.field}>
        <FieldLabel text="Question" required />
        <TextField
          size="small"
          placeholder="Write question"
          disabled={isSubmitting}
          error={!!rowErrors?.question}
          errorMsg={rowErrors?.question?.message}
          inputProps={{ 'data-testid': `program-form-faq-${index}-question` }}
          {...register(`faqs.${index}.question`)}
        />
      </div>
      <div className={styles.field}>
        <FieldLabel text="Answer" required />
        <TextField
          size="small"
          placeholder="Write answer"
          multiline
          minRows={3}
          disabled={isSubmitting}
          error={!!rowErrors?.answer}
          errorMsg={rowErrors?.answer?.message}
          inputProps={{ 'data-testid': `program-form-faq-${index}-answer` }}
          {...register(`faqs.${index}.answer`)}
        />
      </div>
    </>
  );
};
